import action from 'utils/actionCreators';

export const GET_PROJECTS_REQUEST = 'GET_PROJECTS_REQUEST';
export const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';
export const GET_PROJECTS_FAILURE = 'GET_PROJECTS_FAILURE';

export const POST_PROJECT_REQUEST = 'POST_PROJECT_REQUEST';
export const POST_PROJECT_SUCCESS = 'POST_PROJECT_SUCCESS';
export const POST_PROJECT_FAILURE = 'POST_PROJECT_FAILURE';

export const GET_PROJECT_BY_ID_REQUEST = 'GET_PROJECT_BY_ID_REQUEST';
export const GET_PROJECT_BY_ID_SUCCESS = 'GET_PROJECT_BY_ID_SUCCESS';
export const GET_PROJECT_BY_ID_FAILURE = 'GET_PROJECT_BY_ID_FAILURE';

export const UPDATE_PROJECT_BY_ID_REQUEST = 'UPDATE_PROJECT_BY_ID_REQUEST';
export const UPDATE_PROJECT_BY_ID_SUCCESS = 'UPDATE_PROJECT_BY_ID_SUCCESS';
export const UPDATE_PROJECT_BY_ID_FAILURE = 'UPDATE_PROJECT_BY_ID_FAILURE';

export const DELETE_PROJECT_REQUEST = 'DELETE_PROJECT_REQUEST';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_FAILURE = 'DELETE_PROJECT_FAILURE';

export const FAVOURITE_PROJECT_REQUEST = 'FAVOURITE_PROJECT_REQUEST';
export const FAVOURITE_PROJECT_SUCCESS = 'FAVOURITE_PROJECT_SUCCESS';
export const FAVOURITE_PROJECT_FAILURE = 'FAVOURITE_PROJECT_FAILURE';

export const GET_COUNTRIES_REQUEST = 'GET_COUNTRIES_REQUEST';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_FAILURE = 'GET_COUNTRIES_FAILURE';

export const GET_PROJECT_CLIENT_REQUEST = 'GET_PROJECT_CLIENT_REQUEST';
export const GET_PROJECT_CLIENT_SUCCESS = 'GET_PROJECT_CLIENT_SUCCESS';
export const GET_PROJECT_CLIENT_FAILURE = 'GET_PROJECT_CLIENT_FAILURE';

export const GET_PROJECT_CLAIMPAYMENT_REQUEST =
  'GET_PROJECT_CLAIMPAYMENT_REQUEST';
export const GET_PROJECT_CLAIMPAYMENT_SUCCESS =
  'GET_PROJECT_CLAIMPAYMENT_SUCCESS';
export const GET_PROJECT_CLAIMPAYMENT_FAILURE =
  'GET_PROJECT_CLAIMPAYMENT_FAILURE';

export const GET_PROJECT_SEGMENT_REQUEST = 'GET_PROJECT_SEGMENT_REQUEST';
export const GET_PROJECT_SEGMENT_SUCCESS = 'GET_PROJECT_SEGMENT_SUCCESS';
export const GET_PROJECT_SEGMENT_FAILURE = 'GET_PROJECT_SEGMENT_FAILURE';

export const GET_PROJECT_STATES_REQUEST = 'GET_PROJECT_STATES_REQUEST';
export const GET_PROJECT_STATES_SUCCESS = 'GET_PROJECT_STATES_SUCCESS';
export const GET_PROJECT_STATES_FAILURE = 'GET_PROJECT_STATES_FAILURE';

export const GET_PROJECT_CODELIST_REQUEST = 'GET_PROJECT_CODELIST_REQUEST';
export const GET_PROJECT_CODELIST_SUCCESS = 'GET_PROJECT_CODELIST_SUCCESS';
export const GET_PROJECT_CODELIST_FAILURE = 'GET_PROJECT_CODELIST_FAILURE';

export const FILTER_PROJECTS = 'FILTER_PROJECTS';

export const FILTER_PROJECTS_BY_DATE = 'FILTER_PROJECTS_BY_DATE';

export const UPDATE_SEARCH_TEXT = 'PROJECT/UPDATE_SEARCH_TEXT';

export const UPDATE_FORM_FIELD = 'PROJECT/UPDATE_FORM_FIELD';
export const RESET_FORM_FIELD = 'PROJECT/RESET_FORM_FIELD';

export const SELECT_PROJECT_ASSIGNEE = 'PROJECT/SELECT_PROJECT_ASSIGNEE';

export const UPDATE_FORM_FIELD_ERR = 'PROJECT/UPDATE_FORM_FIELD_ERR';
export const RESET_FORM_FIELD_ERR = 'PROJECT/RESET_FORM_FIELD_ERR';

export const GENERATE_ASSIGNEE_FORM = 'PROJECT/GENERATE_ASSIGNEE_FORM';

export const REMOVE_ASSIGNEE_FORM = 'PROJECT/REMOVE_ASSIGNEE_FORM';

export const OPEN_CONFIRMATION_MODAL = 'PROJECT/OPEN_CONFIRMATION_MODAL';
export const CLOSE_CONFIRMATION_MODAL = 'PROJECT/CLOSE_CONFIRMATION_MODAL';

export const UPDATE_PAGINATION_PAGE_NUMBER =
  'PROJECT/UPDATE_PAGINATION_PAGE_NUMBER';

export const UPDATE_PAGINATION_PER_PAGE = 'PROJECT/UPDATE_PAGINATION_PER_PAGE';

export const OPEN_CLIENT_FORM_MODAL = 'PROJECT/OPEN_CLIENT_FORM_MODAL';
export const CLOSE_CLIENT_FORM_MODAL = 'PROJECT/CLOSE_CLIENT_FORM_MODAL';

export const OPEN_RESOURCE_CODE_ASSIGNMENT_MODAL =
  'PROJECT/OPEN_RESOURCE_CODE_ASSIGNMENT_MODAL';
export const CLOSE_RESOURCE_CODE_ASSIGNMENT_MODAL =
  'PROJECT/CLOSE_RESOURCE_CODE_ASSIGNMENT_MODAL';

export const CHECK_UNIDENTIFIED_RESOURCE_CODE_REQUEST =
  'PROJECT/CHECK_UNIDENTIFIED_RESOURCE_CODE_REQUEST';
export const CHECK_UNIDENTIFIED_RESOURCE_CODE_SUCCESS =
  'PROJECT/CHECK_UNIDENTIFIED_RESOURCE_CODE_SUCCESS';
export const CHECK_UNIDENTIFIED_RESOURCE_CODE_FAILURE =
  'PROJECT/CHECK_UNIDENTIFIED_RESOURCE_CODE_FAILURE';

export const SET_IMPORT_UNIDENTIFIED_RESOURCE_CODES =
  'PROJECT/SET_IMPORT_UNIDENTIFIED_RESOURCE_CODES';

export const getProjectsRequest = action(GET_PROJECTS_REQUEST, 'params');
export const postProjectRequest = action(POST_PROJECT_REQUEST, 'payload');
export const getProjectByIdRequest = action(
  GET_PROJECT_BY_ID_REQUEST,
  'params',
);
export const updateProjectByIdRequest = action(
  UPDATE_PROJECT_BY_ID_REQUEST,
  'payload',
);

export const deleteProjectRequest = action(DELETE_PROJECT_REQUEST, 'payload');

export const favouriteProjectRequest = action(
  FAVOURITE_PROJECT_REQUEST,
  'payload',
);

export const getCountriesRequest = action(GET_COUNTRIES_REQUEST, 'payload');

export const getProjectClients = action(GET_PROJECT_CLIENT_REQUEST, 'payload');
export const getProjectSuccess = action(GET_PROJECT_BY_ID_SUCCESS, 'payload');

export const getProjectSegments = action(
  GET_PROJECT_SEGMENT_REQUEST,
  'payload',
);

export const getProjectStates = action(GET_PROJECT_STATES_REQUEST, 'payload');

export const getProjectClaimPaymentAct = action(
  GET_PROJECT_CLAIMPAYMENT_REQUEST,
  'payload',
);

export const getProjectCodeList = action(
  GET_PROJECT_CODELIST_REQUEST,
  'payload',
);

export const filterProjects = action(FILTER_PROJECTS, 'payload');

export const filterProjectsByDate = action(FILTER_PROJECTS_BY_DATE, 'payload');

export const updateSearchText = action(UPDATE_SEARCH_TEXT, 'payload');

export const updateFormField = action(UPDATE_FORM_FIELD, 'payload');
export const resetFormField = action(RESET_FORM_FIELD);

export const selectProjectAssignee = action(SELECT_PROJECT_ASSIGNEE, 'payload');

export const updateFormFieldErr = action(UPDATE_FORM_FIELD_ERR, 'payload');
export const resetFormFieldErr = action(RESET_FORM_FIELD_ERR);

export const generateAssigneeForm = action(GENERATE_ASSIGNEE_FORM);

export const removeAssigneeForm = action(REMOVE_ASSIGNEE_FORM, 'payload');

export const openConfirmationModal = action(OPEN_CONFIRMATION_MODAL, 'payload');
export const closeConfirmationModal = action(CLOSE_CONFIRMATION_MODAL);

export const updatePaginationPageNumber = action(
  UPDATE_PAGINATION_PAGE_NUMBER,
  'payload',
);

export const updatePaginationPerPage = action(
  UPDATE_PAGINATION_PER_PAGE,
  'payload',
);

export const openClientFormModal = action(OPEN_CLIENT_FORM_MODAL);
export const closeClientFormModal = action(CLOSE_CLIENT_FORM_MODAL);

export const openResourceCodeAssignmentModal = action(
  OPEN_RESOURCE_CODE_ASSIGNMENT_MODAL,
);
export const closeResourceCodeAssignmentModal = action(
  CLOSE_RESOURCE_CODE_ASSIGNMENT_MODAL,
);

export const checkUnidentifiedResourceCodeRequest = action(
  CHECK_UNIDENTIFIED_RESOURCE_CODE_REQUEST,
  'payload',
);

export const setImportUnidentifiedResourceCodes = action(
  SET_IMPORT_UNIDENTIFIED_RESOURCE_CODES,
  'payload',
);
